import React, { Component } from 'react';
import './App.css';
import logoBanner from './assets/images/logo-banner.png';
import ad1 from './assets/images/ad1.jpg';
import ad2 from './assets/images/ad2.jpg';
import ad3 from './assets/images/ad3.jpg';
import ad4 from './assets/images/ad4.jpg';
import ad5 from './assets/images/ad5.jpg';
import ad6 from './assets/images/ad6.jpg';
import middle from './assets/images/middle.jpg';
import footer from './assets/images/footer.jpg';
import { services } from './services/services';
import { utils } from './utils/utils';
import moment from 'moment';
import loading from './assets/images/loading.gif';

const timeStr = '15:00';

const getScheduleDates = (baseDate) => {
  const dateObj = baseDate ? moment(baseDate) : moment();
  const timeAnnounce = dateObj.format('YYYY-MM-DD 14:50:00');
  return {
    announceStartDate: moment(timeAnnounce).format('YYYY-MM-DD HH:mm:ss'),
    beforeStartUpAnnounceDate: moment(timeAnnounce).format('YYYY-MM-DD HH:mm:ss'),
    afterStartUpAnnounceDate: moment(timeAnnounce).add(4.59, 'minute').format('YYYY-MM-DD HH:mm:ss'),
    startUpAnnounceDate: moment(timeAnnounce).add(5, 'minute').format('YYYY-MM-DD HH:mm:ss'),
    endUpAnnouneDate: moment(timeAnnounce).add(9.59, 'minute').format('YYYY-MM-DD HH:mm:ss'),
    upAnnounceDate: moment(timeAnnounce).add(10, 'minute').format('YYYY-MM-DD HH:mm:ss'),
    announceEndDate: moment(timeAnnounce).add(10, 'minute').format('YYYY-MM-DD HH:mm:ss'),
  };
};

const imageLoading = () => {
  return <img
    style={{ marginRight: 2 }}
    src={loading}
    width={30}
    height={30}
    alt='number'
  />;
}

class App extends Component {

  animationTimer = null;
  upTimer = null;
  lastFetchTime = 0;

  constructor() {
    super();

    this.state = {
      periods: null,
      previousPeriod: null,
      currentPeriod: null,
      numberAnnounce: {
        number1: imageLoading(),
        number2: imageLoading(),
        number3: imageLoading(),
        number4: imageLoading(),
        number5: imageLoading()
      },
      todayDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      oldUpAnnounce: false,
      beforeAnnonce: false,
      beforeStartUp: false,
      upAnnounce: false,
      afterAnnounce: false,
      isShowing: false,

    }
  }

  componentDidMount() {
    this.getAllStatistics();
    this.initData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.animationTimer);
    clearInterval(this.upTimer);
  }

  initData = () => {
    this.animationTimer = setInterval(() => {
      const now = moment().format('YYYY-MM-DD HH:mm:ss');
      this.setState({ todayDate: now });

      const { announceStartDate, announceEndDate } = getScheduleDates(now);
      const nowTime = moment(now).toDate().getTime();

      if (nowTime < moment(announceStartDate).toDate().getTime()) {
        this.beforeAnnonce();
      } else if (
        nowTime >= moment(announceStartDate).toDate().getTime()
        && nowTime <= moment(announceEndDate).toDate().getTime()
      ) {
        this.intervalData();
      } else {
        this.afterAnnounce();
      }
    }, 1000);
  }

  beforeAnnonce = async () => {
    const { todayDate, beforeAnnonce } = this.state;
    if (!beforeAnnonce) {
      const dateNow = moment(todayDate).add(-1, 'd').format(`YYYY-MM-DD ${timeStr}:00`);
      const period = await services.getPeriods(dateNow, 'both', '2');
      const up = period?.data?.up6;
      if (up) {
        this.setState({
          numberAnnounce: {
            number1: up[0],
            number2: up[1],
            number3: up[2],
            number4: up[3],
            number5: up[4]
          },
          beforeAnnonce: true,
          isShowing: true
        });
      }
    }
  }

  intervalData = async () => {
    const { todayDate, oldUpAnnounce, upAnnounce, beforeStartUp } = this.state;
    const {
      beforeStartUpAnnounceDate,
      afterStartUpAnnounceDate,
      startUpAnnounceDate,
      endUpAnnouneDate,
      upAnnounceDate
    } = getScheduleDates(todayDate);

    const nowTime = moment(todayDate).toDate().getTime();

    if (nowTime < moment(startUpAnnounceDate).toDate().getTime()) {
      if (!oldUpAnnounce) {
        this.setState({
          numberAnnounce: {
            number1: imageLoading(),
            number2: imageLoading(),
            number3: imageLoading(),
            number4: imageLoading(),
            number5: imageLoading()
          },
          oldUpAnnounce: true,
          isShowing: false
        });
      }
    }

    if (nowTime >= moment(beforeStartUpAnnounceDate).toDate().getTime() && nowTime <= moment(afterStartUpAnnounceDate).toDate().getTime()) {
      if (!beforeStartUp) {
        this.setState({
          numberAnnounce: {
            number1: imageLoading(),
            number2: imageLoading(),
            number3: imageLoading(),
            number4: imageLoading(),
            number5: imageLoading()
          },
          beforeStartUp: true,
          isShowing: false
        });
      }
    }

    if (nowTime >= moment(startUpAnnounceDate).toDate().getTime() && nowTime <= moment(endUpAnnouneDate).toDate().getTime()) {
      if (this.upTimer === null) {
        this.upTimer = setInterval(() => {
          this.setState({
            numberAnnounce: {
              number1: Math.floor(Math.random() * 10),
              number2: Math.floor(Math.random() * 10),
              number3: Math.floor(Math.random() * 10),
              number4: Math.floor(Math.random() * 10),
              number5: Math.floor(Math.random() * 10),
            },
            isShowing: false
          })
        }, 100);
      }
    }

    if (nowTime >= moment(upAnnounceDate).toDate().getTime()) {
      if (!upAnnounce) {
        // Cooldown/Throttle check
        const nowMs = Date.now();
        if (nowMs - this.lastFetchTime < 30000) {
          return;
        }
        this.lastFetchTime = nowMs;

        const statisticToday = await services.getStatisticToday();
        const up = statisticToday?.data?.up6;

        if (up) {
          clearInterval(this.upTimer);
          this.upTimer = null;
          this.setState({
            numberAnnounce: {
              number1: up[0],
              number2: up[1],
              number3: up[2],
              number4: up[3],
              number5: up[4]
            },
            upAnnounce: true,
            isShowing: true
          });
        } else {
          // If result is not ready, make sure the spinning is active
          if (this.upTimer === null) {
            this.upTimer = setInterval(() => {
              this.setState({
                numberAnnounce: {
                  number1: Math.floor(Math.random() * 10),
                  number2: Math.floor(Math.random() * 10),
                  number3: Math.floor(Math.random() * 10),
                  number4: Math.floor(Math.random() * 10),
                  number5: Math.floor(Math.random() * 10),
                },
                isShowing: false
              })
            }, 100);
          }
        }
      }
    }
  }

  afterAnnounce = async () => {
    const { afterAnnounce } = this.state;
    if (!afterAnnounce) {
      // Cooldown/Throttle check
      const nowMs = Date.now();
      if (nowMs - this.lastFetchTime < 30000) {
        return;
      }
      this.lastFetchTime = nowMs;

      const statisticToday = await services.getStatisticToday();
      const up = statisticToday?.data?.up6;
      if (up) {
        clearInterval(this.upTimer);
        this.upTimer = null;
        this.setState({
          numberAnnounce: {
            number1: up[0],
            number2: up[1],
            number3: up[2],
            number4: up[3],
            number5: up[4],
          },
          afterAnnounce: true,
          isShowing: true
        })
      } else {
        if (this.upTimer === null) {
          this.upTimer = setInterval(() => {
            this.setState({
              numberAnnounce: {
                number1: Math.floor(Math.random() * 10),
                number2: Math.floor(Math.random() * 10),
                number3: Math.floor(Math.random() * 10),
                number4: Math.floor(Math.random() * 10),
                number5: Math.floor(Math.random() * 10),
              },
              isShowing: false
            })
          }, 100);
        }
      }
    }
  }

  getAllStatistics = async () => {
    const response = await services.getStatistics();
    this.setState({
      periods: response.data
    })
  }

  renderPeriods() {
    const { periods } = this.state;

    if (!periods) {
      return (
        <tr className="text-center">
          <td colSpan={7}>ไม่มีข้อมูล</td>
        </tr>
      );
    }

    if (periods.length === 0) {
      return (
        <tr className="text-center">
          <td colSpan={7}>ไม่มีข้อมูล</td>
        </tr>
      );
    }

    return periods.map((period, index) => {
      return (
        <tr key={index} className="text-center">
          <td>{utils.convertToThaiDate(period?.dateAnnounce.toString())}</td>
          <td style={{ verticalAlign: 'middle' }}>{period.up6}</td>
          <td style={{ verticalAlign: 'middle' }}>{period.up3}</td>
          <td style={{ verticalAlign: 'middle' }}>{period.up2}</td>
          <td style={{ verticalAlign: 'middle' }}>{period.down2}</td>
        </tr>
      );
    });
  }

  renderDateTime = () => {
    const { todayDate } = this.state;
    const { beforeStartUpAnnounceDate } = getScheduleDates(todayDate);
    if (moment(todayDate).toDate().getTime() >= moment(beforeStartUpAnnounceDate).toDate().getTime()) {
      return 'ງວດປະຈຳວັນທີ່ ' + utils.convertToThaiDate(moment(todayDate).toString());
    }

    return 'ງວດປະຈຳວັນທີ່ ' + utils.convertToThaiDate(moment(todayDate).add(-1, 'd').toString());
  }

  renderAnnounceShowing = () => {

    const { numberAnnounce, isShowing } = this.state;
    return <>
      {/* <div>
        <div className="content">
          <p>ເລກ 6 ໂຕ</p>
          <p className="result-digit">{isShowing ? `${numberAnnounce.number1}${numberAnnounce.number2}${numberAnnounce.number3}${numberAnnounce.number4}${numberAnnounce.number5}${numberAnnounce.number6}` : imageLoading()}</p>
        </div>
      </div> */}
      <div>
        <div className="content">
          <p>ເລກ 5 ໂຕ</p>
          <p className="result-digit">{isShowing ? `${numberAnnounce.number1}${numberAnnounce.number2}${numberAnnounce.number3}${numberAnnounce.number4}${numberAnnounce.number5}` : imageLoading()}</p>
        </div>
      </div>
      <div>
        <div className="content">
          <p>ເລກ 4 ໂຕ</p>
          <p className="result-digit">{isShowing ? `${numberAnnounce.number2}${numberAnnounce.number3}${numberAnnounce.number4}${numberAnnounce.number5}` : imageLoading()}</p>
        </div>
      </div>
      <div>
        <div className="content">
          <p>ເລກ 3 ໂຕ</p>
          <p className="result-digit">{isShowing ? `${numberAnnounce.number3}${numberAnnounce.number4}${numberAnnounce.number5}` : imageLoading()}</p>
        </div>
      </div>
      <div>
        <div className="content">
          <p>ເລກ 2 ໂຕລຸ່ມ</p>
          <p className="result-digit">{isShowing ? `${numberAnnounce.number1}${numberAnnounce.number2}` : imageLoading()}</p>
        </div>
      </div>
      <div>
        <div className="content">
          <p>ເລກ 2 ໂຕເທິ່ງ</p>
          <p className="result-digit">{isShowing ? `${numberAnnounce.number4}${numberAnnounce.number5}` : imageLoading()}</p>
        </div>
      </div>
    </>
  }

  render() {

    const { numberAnnounce } = this.state;

    return (
      <div className="container">
        <img src={logoBanner} className="img-fluid mb-2 banner-logo" alt="laomaekhong" />
        <div className="row">
          <div className="col-md-9 col-sm-12 col-xs-12">
            <div className="inner-background">
              <div className="box">
                <div className="text-center p-2 logo-gradient">
                  <h4>{this.renderDateTime()}</h4>
                </div>
                <div className="mb-4">
                  <div className="flexbox">
                    <div className="item">
                      <div className="content-box">
                        <p className="content-number">{numberAnnounce.number1}</p>
                      </div>
                    </div>
                    <div className="item">
                      <div className="content-box">
                        <p className="content-number">{numberAnnounce.number2}</p>
                      </div>
                    </div>
                    <div className="item">
                      <div className="content-box">
                        <p className="content-number">{numberAnnounce.number3}</p>
                      </div>
                    </div>
                    <div className="item">
                      <div className="content-box">
                        <p className="content-number">{numberAnnounce.number4}</p>
                      </div>
                    </div>
                    <div className="item">
                      <div className="content-box">
                        <p className="content-number">{numberAnnounce.number5}</p>
                      </div>
                    </div>
                    {/* <div className="item">
                      <div className="content-box">
                        <p className="content-number">{numberAnnounce.number6}</p>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="text-center">
                  <h2>ເວລາອອກເລກ {`${timeStr}`}</h2>
                </div>
              </div>

              <div className="grid">
                {this.renderAnnounceShowing()}
              </div>
            </div>
            <div className="inner-background">
              <div className="card d-flex justify-content-center mt-0">
                <div className="card-body p-0">
                  <img src={footer} width="100%" alt="หวย หวยลาว ลาว ຫວຍລາວສາລະວັນ หวยลาวสาละวัน " />
                </div>
              </div>
            </div>

            <div className="stat">
              <div className="text-center header-state">
                <h5>ຜົນລາງວັນທີ່ຜ່ານມາ</h5>
              </div>
              <table className="table table-bordered period" id="period-table">
                <thead>
                  <tr className="text-center">
                    <th style={{ verticalAlign: 'middle' }}>ງວດວັນທີ່</th>
                    <th>ເລກ 6 ໂຕ</th>
                    <th>ເລກ 3 ໂຕ</th>
                    <th>ເລກ 2 ໂຕເທິງ</th>
                    <th>ເລກ 2 ໂຕລຸ່ມ</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {this.renderPeriods()}
                </tbody>
              </table>
            </div>

            <div className="inner-background">
              <div className="card d-flex justify-content-center mt-0">
                <div className="card-body p-0">
                  <img src={middle} width="100%" alt="หวย หวยลาว ลาว ຫວຍລາວສາລະວັນ หวยลาวสาละวัน " />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-12 col-xs-12">
            <div className="card d-flex justify-content-center mt-0">
              <div className="card-body p-0">
                <img src={ad1} width="100%" height={350} alt="หวย หวยลาว ลาว ຫວຍລາວສາລະວັນ หวยลาวสาละวัน " />
              </div>
            </div>
            <div className="card d-flex justify-content-center mt-2">
              <div className="card-body p-0">
                <img src={ad5} width="100%" alt="หวย หวยลาว ลาว ຫວຍລາວສາລະວັນ หวยลาวสาละวัน " />
              </div>
            </div>
            <div className="card d-flex justify-content-center mt-2">
              <div className="card-body p-0">
                <img src={ad2} width="100%" height={330} alt="หวย หวยลาว ลาว ຫວຍລາວສາລະວັນ หวยลาวสาละวัน " />
              </div>
            </div>
            <div className="card d-flex justify-content-center mt-2">
              <div className="card-body p-0">
                <img src={ad3} width="100%" alt="หวย หวยลาว ลาว ຫວຍລາວສາລະວັນ หวยลาวสาละวัน " />
              </div>
            </div>
            <div className="card d-flex justify-content-center mt-2">
              <div className="card-body p-0">
                <img src={ad4} width="100%" alt="หวย หวยลาว ลาว ຫວຍລາວສາລະວັນ หวยลาวสาละวัน " />
              </div>
            </div>
            <div className="card d-flex justify-content-center mt-2">
              <div className="card-body p-0">
                <img src={ad6} width="100%" height={275} alt="หวย หวยลาว ลาว ຫວຍລາວສາລະວັນ หวยลาวสาละวัน " />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default App;
